export default "__VITE_ASSET__1aa5b2cc__"